import React from 'react';
import './MessageCard.css';

const MessageCard = ({ message, onClose, isError }) => {
    const cardStyle = isError ? 
    {
        backgroundColor: '#ffcccc', // Light red background
        border: '1px solid #ff6666', // Red border
        color: '#cc0000'
    } : 
    {
        backgroundColor: '#ccffcc', // Light green background
        border: '1px solid #66ff66',
        color: '#005518'
    };
    return (
        <div>
            <div className="message-card" style={cardStyle}>
                <p>{message}</p>
                <button onClick={onClose}>X</button>
            </div>
        </div>
    );
};

export default MessageCard;
